export const AdPageTestIds = {
  price: 'ad-price',
  title: 'ad-title',
  description: 'ad-description',
  propertiesItem: 'properties-item',
  propertiesItemLabel: 'properties-item-label',
  propertiesItemValue: 'properties-item-value',
  slider: {
    counter: 'slider-counter',
    image: 'slider-image',
  },
  authorInfo: {
    main: 'author-info-main',
    name: 'author-info-name',
    workingHours: 'author-info-working-schedule',
    link: 'author-info-link',
    avatar: 'author-info-avatar',
    defaultAvatar: 'author-info-default-avatar',
    warning: 'author-info-warning',
    warningText: 'author-info-warning-text',
  },
  complaint: {
    box: 'complaint-box',
    title: 'complaint-title',
    reportReason: 'complaint-report-reason',
    reset: 'complaint-reset',
    textarea: 'complaint-textarea',
    submit: 'complaint-submit',
    popup: 'complaint-popup',
  },
  statusBanner: {
    banner: 'status-banner',
    text: 'status-banner-text',
    button: 'status-banner-button',
    restoredAdDrawer: 'status-banner-restored-ad-drawer',
    restoredAdDrawerBtn: 'status-banner-restored-ad-drawer-btn',
    restoredAdPopup: 'status-banner-restored-ad-popup',
    payByBalancePopup: 'status-banner-pay-by-balance-popup',
    prolongByBalancePopup: 'status-banner-prolong-by-balance-popup',
  },
  remove: {
    sheet: 'ad-remove-sheet',
    continueButton: 'ad-remove-continue',
    submitButton: 'ad-remove-submit',
    descriptionInput: 'ad-remove-description',
  },
  settings: {
    views: 'setting-views',
    contacts: {
      self: 'setting-contacts',
      bottomSheet: {
        self: 'setting-contacts-bottom-sheet',
        title: 'setting-contacts-bottom-sheet-title',
        button: 'setting-contacts-bottom-sheet-button',
      },
    },
    inFavorites: 'setting-in-favorites',
    label: 'setting-label',
    value: 'setting-value',
    daysToDeactivation: 'setting-dates-to-deactivation',
    editButton: 'setting-edit-button',
    remove: {
      button: 'setting-remove-button',
      popup: 'setting-remove-popup',
    },
    editPopup: 'setting-edit-popup',
    editPendingPopup: 'setting-edit-pending-popup',
  },
  chatButton: 'chat-button',
  callButton: 'call-button',
  promotions: {
    box: 'promotions-box',
  },
  promotionButton: {
    bump: 'promotion_bumped',
    vip: 'promotion_vipped',
    premium: 'promotion_premium',
    bumpIsAuthor: 'isAuthor_promotion_bumped',
    vipIsAuthor: 'isAuthor_promotion_vipped',
    premiumIsAuthor: 'isAuthor_promotion_premium',
  },
  promotionDrawer: {
    drawer: 'promotion-drawer',
    services: 'promotion-drawer-services',
    payButton: 'promotion-drawer-pay-button',
    bonusLabel: 'promotion-drawer-bonus-label',
    subheader: {
      subtitle: 'promotion-drawer-subheader-subtitle',
      row1Text: 'promotion-drawer-subheader-row1-text',
      row1Message: 'promotion-drawer-subheader-row1-message',
      row2Text: 'promotion-drawer-subheader-row2-text',
      row2Message: 'promotion-drawer-subheader-row2-message',
    },
    terminalPaymentDrawer: 'promotion-drawer-terminal-payment-drawer',
  },
  terminalPaymentDrawer: {
    drawer: 'terminal-payment-drawer',
    phone: 'terminal-payment-drawer-phone',
    service: 'terminal-payment-drawer-service',
    price: 'terminal-payment-drawer-price',
    okButton: 'terminal-payment-drawer-ok-button',
  },
  popup: {
    success: 'popup-success',
    restoredSuccess: 'popup-restored-success',
    notEnoughFunds: 'popup-not-enough-funds',
    errorAddBalance: 'popup-error-add-balance',
    payByBalance: 'popup-pay-by-balance',
    prolongByBalance: 'prolong-pay-by-balance',
  },
  myCards: {
    triggerButton: 'my-cards-trigger-button',
    bottomSheet: {
      self: 'my-cards-bottom-sheet',
      card: 'my-cards-bottom-sheet-card',
    },
  },
  paymentFlowDrawer: {
    drawer: 'payment-flow-drawer',
    promotionDrawer: 'payment-flow-drawer-promotion-drawer',
    continueButton: 'payment-flow-drawer-continue-button',
    restoredAdPopup: 'payment-flow-drawer-restored-ad-popup',
  },
  paymentProviderIcons: {
    googlePayIcon: 'google-pay-icon',
    applePayIcon: 'apple-pay-icon',
  },
  addBalanceDrawer: {
    drawer: 'add-balance-drawer',
    button: 'add-balance-drawer-button',
  },
  headerActions: {
    bookmarkIcon: 'header-actions-bookmark-icon',
  },
};
